(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminCustomerAccountDetailController', NasracAdminCustomerAccountDetailController);

    NasracAdminCustomerAccountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'NasracAdminCustomerAccount'];

    function NasracAdminCustomerAccountDetailController($scope, $rootScope, $stateParams, previousState, entity, NasracAdminCustomerAccount) {
        var vm = this;

        vm.nasracAdminCustomerAccount = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('nasracApp:nasracAdminCustomerAccountUpdate', function(event, result) {
            vm.nasracAdminCustomerAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
